import { useEffect } from "react";
import { LAYOUT_HEADER_HEIGHT_PX } from "../Utils/storage-constants";

const useViewportHeight = () => {
  useEffect(() => {
    const setRealVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--real-vh", `${vh}px`);
    };

    setRealVh();
    document.documentElement.style.setProperty(
      "--header-height",
      `${LAYOUT_HEADER_HEIGHT_PX}px`
    );
    window.addEventListener("resize", setRealVh);

    return () => window.removeEventListener("resize", setRealVh);
  }, []);
};

export default useViewportHeight;
